import React, { useCallback } from 'react';
import type { ReactNode } from 'react';

import { useSellerContext } from './SellerContext';
import type { Seller } from './SellerContext';
import { CurrentSellerProvider } from './CurrentSellerContext';
import { useCssHandles } from '../../../utils/functions';

const SELLERS_CSS_HANDLES = ['sellerList'];

interface Props {
	children: ReactNode;
	componentId?: string;
	blockClass?: string;
}

function SellerBody({ children, componentId, blockClass }: Props) {
	const { sellerList, shippingQuotes } = useSellerContext();
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	const currentSellerCreate = useCallback(
		(current: Seller, index: number) => {
			const currentContext = {
				currentSeller: current,
				shipping: shippingQuotes?.logisticsInfo ? shippingQuotes.logisticsInfo[index] : null,
			};

			return currentContext;
		},
		[shippingQuotes],
	);

	return (
		<div data-selection={componentId} className={`${handles.sellerList} mh7 mb7`}>
			{sellerList
				? sellerList.map((current, index: number) => (
						<CurrentSellerProvider value={currentSellerCreate(current, index)} key={index}>
							{children}
						</CurrentSellerProvider>
					))
				: null}
		</div>
	);
}

export default SellerBody;
